var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMensajes = function SvgMensajes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "mensajes_svg__Capa_2",
    viewBox: "0 0 25.7 24.09"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mensajes_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.65 0H4.04C1.81 0 0 1.81 0 4.04v11.79c0 2.23 1.81 4.04 4.04 4.04h1.94v3.03c0 .97 1.1 1.53 1.88.96 1.66-1.2 4.02-2.92 5.45-3.99h8.34c2.23 0 4.04-1.81 4.04-4.04V4.04c0-2.23-1.81-4.04-4.04-4.04",
    fill: "#500d76"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 2.73,
    x: 5.6,
    y: 5.95,
    rx: 1.37,
    ry: 1.37,
    fill: "#55ddd2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 2.73,
    x: 5.6,
    y: 11.09,
    rx: 1.37,
    ry: 1.37,
    fill: "#fff"
  }))));
};
export default SvgMensajes;